"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleFutures = exports.OrderInnerStatus = void 0;
var OrderInnerStatus;
(function (OrderInnerStatus) {
    OrderInnerStatus["Initialize"] = "initialize";
    OrderInnerStatus["CreateStrategy"] = "create_strategy";
    OrderInnerStatus["allocatingFund"] = "allocating_fund";
    OrderInnerStatus["createOrder"] = "create_order";
    OrderInnerStatus["AllocateFund"] = "allocate_fund";
    OrderInnerStatus["MainLoop"] = "main_loop";
    OrderInnerStatus["ClosePosition"] = "close_position";
    OrderInnerStatus["ClearStrategy"] = "clear_strategy";
    OrderInnerStatus["PreTransfer"] = "pre-transfer";
    OrderInnerStatus["Transfering"] = "transfering";
    OrderInnerStatus["TransferIn"] = "transfer_in";
    OrderInnerStatus["TransferOut"] = "transfer_out";
    OrderInnerStatus["Canceled"] = "canceled";
})(OrderInnerStatus = exports.OrderInnerStatus || (exports.OrderInnerStatus = {}));
var SimpleFutures;
(function (SimpleFutures) {
    /** 订单状态 */
    let OrderStatus;
    (function (OrderStatus) {
        /** 默认值，运行中的仓位列表 */
        OrderStatus["running"] = "running";
        /** 历史仓位列表 */
        OrderStatus["finished"] = "finished";
    })(OrderStatus = SimpleFutures.OrderStatus || (SimpleFutures.OrderStatus = {}));
    let OrderSubStatus;
    (function (OrderSubStatus) {
        /** 待触发订单 */
        OrderSubStatus["waiting_trigger"] = "waiting_trigger";
        /** 已触发订单或无需触发订单 */
        OrderSubStatus["running"] = "running";
    })(OrderSubStatus = SimpleFutures.OrderSubStatus || (SimpleFutures.OrderSubStatus = {}));
    /** 简易合约投资类型 */
    let InvestmentFrom;
    (function (InvestmentFrom) {
        /** 发财金 */
        InvestmentFrom["FUTURES_LITE_BONUS"] = "FUTURES_LITE_BONUS";
    })(InvestmentFrom = SimpleFutures.InvestmentFrom || (SimpleFutures.InvestmentFrom = {}));
    /** pro 模式的 TPSL 本次存储类型 */
    let ProTradeStorageTPSLInputMode;
    (function (ProTradeStorageTPSLInputMode) {
        ProTradeStorageTPSLInputMode["percent"] = "percent";
        ProTradeStorageTPSLInputMode["price"] = "price";
        ProTradeStorageTPSLInputMode["pnl"] = "pnl";
    })(ProTradeStorageTPSLInputMode = SimpleFutures.ProTradeStorageTPSLInputMode || (SimpleFutures.ProTradeStorageTPSLInputMode = {}));
    /** tpsl止盈止损的模式 */
    let TPSLMode;
    (function (TPSLMode) {
        /** 追踪模式 */
        TPSLMode["simple_trailing"] = "simple_trailing";
        /** 按收益率模式 */
        TPSLMode["simple_rate"] = "simple_rate";
        /** 按价格 */
        TPSLMode["simple_price"] = "simple_price";
        /** 按收益额 */
        TPSLMode["simple_amount"] = "simple_amount";
    })(TPSLMode = SimpleFutures.TPSLMode || (SimpleFutures.TPSLMode = {}));
    let TPSLStateEnum;
    (function (TPSLStateEnum) {
        TPSLStateEnum["not_set"] = "not_set";
        TPSLStateEnum["normal"] = "normal";
        TPSLStateEnum["too_high"] = "too_high";
        TPSLStateEnum["too_low"] = "too_low";
        TPSLStateEnum["too_close"] = "too_close";
    })(TPSLStateEnum = SimpleFutures.TPSLStateEnum || (SimpleFutures.TPSLStateEnum = {}));
    let OrderMode;
    (function (OrderMode) {
        OrderMode["Market"] = "market";
        /** 条件单 */
        OrderMode["Trigger"] = "trigger";
        /** 限价单 */
        OrderMode["Limit"] = "limit";
    })(OrderMode = SimpleFutures.OrderMode || (SimpleFutures.OrderMode = {}));
})(SimpleFutures = exports.SimpleFutures || (exports.SimpleFutures = {}));
